export default __webpack_public_path__ + "static/media/logo.ee4a2aca.PNG";